import { render, staticRenderFns } from "./PerformancePanel.vue?vue&type=template&id=3c887c68&scoped=true"
import script from "./PerformancePanel.vue?vue&type=script&lang=js"
export * from "./PerformancePanel.vue?vue&type=script&lang=js"
import style0 from "./PerformancePanel.vue?vue&type=style&index=0&id=3c887c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c887c68",
  null
  
)

export default component.exports